import React from "react";

export default function Checkmark() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
      <g clip-path="url(#clip0_1_2454)">
        <path d="M2.18645 1.7993C5.32651 5.47277 8.51425 9.03739 12.4444 11.8877C12.8531 12.1871 13.4866 12.0918 13.868 11.7857C14.2086 11.5136 14.3652 10.9898 13.9566 10.6973C12.097 9.35032 10.3465 7.86052 8.73902 6.22107C7.13153 4.58161 5.53085 2.71086 3.98466 0.90134C3.6509 0.520387 3.07193 0.499979 2.636 0.724469C2.29543 0.894537 1.85269 1.41154 2.18645 1.8061V1.7993Z" fill="#EC6525" />
        <path d="M10.4828 1.03744C7.77864 4.89458 5.56493 9.07825 2.8608 12.9354C2.59516 13.3163 3.09239 13.4864 3.39209 13.5C3.82121 13.5136 4.43424 13.3436 4.69307 12.9694C7.3972 9.10546 9.61091 4.92179 12.315 1.06465C12.5807 0.683696 12.0835 0.513628 11.7838 0.500022C11.3546 0.486417 10.7416 0.656485 10.4828 1.03063V1.03744Z" fill="#EC6525" />
        <path d="M0.892261 7.63606C5.54445 7.15986 10.2784 7.22789 14.8965 6.45238C15.2984 6.38435 15.9319 6.19388 16 5.70408C16.0613 5.2483 15.4619 5.08504 15.1077 5.13946C10.4895 5.91497 5.75561 5.84694 1.10341 6.32313C0.701542 6.36395 0.0612691 6.60204 -3.35602e-05 7.07143C-0.0613362 7.54082 0.538068 7.67007 0.892261 7.63606Z" fill="#EC6525" />
      </g>
      <defs>
        <clipPath id="clip0_1_2454">
          <rect width="16" height="13" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
